import { Fragment, useEffect, useState } from 'react';

import RouteContentRenderer from '@/components/routes/route-content-renderer';
import SidePanel from '@/components/shared/side-panel';
import useRouteSearch from '@/hooks/use-route-search';
import useRoutesState from '@/hooks/use-routes-state';

const Routes = () => {
  const [selectedTab, setSelectedTab] = useState('pearl-chain');
  const [isAllExpanded, setIsAllExpanded] = useState(false);

  const {
    viewType,
    isShowSidePanel,
    hasBackIcon,
    handleClose,
    handleBack,
    headerText,
    hasHeaderBottomBorder,
    paramRouteLineNumber,
  } = useRoutesState();

  useRouteSearch(viewType);

  useEffect(() => {
    setSelectedTab('pearl-chain');
    setIsAllExpanded(false);
  }, [viewType]);

  const onSelectReservationTab = (newTab: string) => {
    setSelectedTab(newTab);

    if (isAllExpanded) {
      setIsAllExpanded(false);
    }
  };

  return (
    <SidePanel
      header={headerText}
      viewType={viewType}
      isSidePanelOpen={isShowSidePanel}
      setSidePanelOpen={handleClose}
      hasBackIcon={hasBackIcon}
      onClickBackIcon={handleBack}
      hasHeaderBottomBorder={hasHeaderBottomBorder}
    >
      <Fragment key={viewType}>
        <RouteContentRenderer
          viewType={viewType}
          onSelectReservationTab={onSelectReservationTab}
          selectedTab={selectedTab}
          isAllExpanded={isAllExpanded}
          onAllExpand={setIsAllExpanded}
          currentLineNumber={paramRouteLineNumber}
        />
      </Fragment>
    </SidePanel>
  );
};

export default Routes;
